/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 49a830b3 (Tue Jan 27 16:18:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  TuitionPayments2,
  TuitionPayments2FromJSON,
  TuitionPayments2ToJSON,
} from './'

/**
 *
 * @export
 * @interface UpdateInvoiceLineRequestBody
 */
export interface UpdateInvoiceLineRequestBody {
  /**
   * The unique identifier for the invoice.
   * @type number
   * @memberof UpdateInvoiceLineRequestBody
   */
  invoiceKey: number
  /**
   * The unique identifier for the payment
   * @type number
   * @memberof UpdateInvoiceLineRequestBody
   */
  paymentKey: number
  /**
   * The total amount of the payments being added
   * @type string
   * @memberof UpdateInvoiceLineRequestBody
   */
  totalAmount: string
  /**
   * Date the user received the payment from the parent for the program
   * @type Date
   * @memberof UpdateInvoiceLineRequestBody
   */
  dateReceived?: Date
  /**
   * Description that goes along with the payment
   * @type string
   * @memberof UpdateInvoiceLineRequestBody
   */
  description: string
  /**
   * Whether invoice is discounted
   * @type boolean
   * @memberof UpdateInvoiceLineRequestBody
   */
  isDiscount?: boolean
  /**
   * The tuition payments to add
   * @type {Array<TuitionPayments2>}
   * @memberof UpdateInvoiceLineRequestBody
   */
  tuitionPayments: Array<TuitionPayments2>
}

export function UpdateInvoiceLineRequestBodyFromJSON(
  json: any
): UpdateInvoiceLineRequestBody {
  return UpdateInvoiceLineRequestBodyFromJSONTyped(json, false)
}

export function UpdateInvoiceLineRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateInvoiceLineRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    invoiceKey: json['invoiceKey'],
    paymentKey: json['paymentKey'],
    totalAmount: json['totalAmount'],
    dateReceived: !exists(json, 'dateReceived')
      ? undefined
      : new Date(json['dateReceived']),
    description: json['description'],
    isDiscount: !exists(json, 'isDiscount') ? undefined : json['isDiscount'],
    tuitionPayments: (json['tuitionPayments'] as Array<any>).map(
      TuitionPayments2FromJSON
    ),
  }
}

export function UpdateInvoiceLineRequestBodyToJSON(
  value?: UpdateInvoiceLineRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    invoiceKey: value.invoiceKey,
    paymentKey: value.paymentKey,
    totalAmount: value.totalAmount,
    dateReceived:
      value.dateReceived === undefined
        ? undefined
        : value.dateReceived.toISOString(),
    description: value.description,
    isDiscount: value.isDiscount,
    tuitionPayments: (value.tuitionPayments as Array<any>).map(
      TuitionPayments2ToJSON
    ),
  }
}
